import React, { useEffect } from "react";
import "./Categories.css";
import Black_Btn from "../../common_components/common_btn/Black_Btn/Black_Btn";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import { useNavigate } from "react-router-dom";
import { Autoplay } from "swiper/modules";
import 'swiper/css';

const Categories = () => {
  const dispatch = useDispatch();

  const categories = useSelector((state) => state.master.categories);
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const navigate = useNavigate();

  const handleCategoryClick = (id, product, img) => {
    navigate(
      `/product-listing/${id}?category_name=${encodeURIComponent(
        product,
      )}&category_image=${encodeURIComponent(img)}`,
    );
    // }
  };

  return (
    <section className="Categories">
      <div className="container">
        <div className="main_div">
          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="blue_div">
                <p className="text1">Comfort</p>
                <p className="text2">Crafted with</p>
                <p className="text3">Elegance!</p>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="category_swiper">
                <Swiper
  modules={[Autoplay]}
  spaceBetween={30}
  loop={true}
  grabCursor={true}
  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  }}
  breakpoints={{
    0: { slidesPerView: 1.2, spaceBetween: 10 },
    360: { slidesPerView: 1.8, spaceBetween: 10 },
    425: { slidesPerView: 2, spaceBetween: 20 },
    640: { slidesPerView: 2, spaceBetween: 10 },
    768: { slidesPerView: 3, spaceBetween: 10 },
    992: { slidesPerView: 3, spaceBetween: 5 },
    1200: { slidesPerView: 3, spaceBetween: 8 },
    1400: { slidesPerView: 3.1, spaceBetween: 10 },
  }}
>
                  {categories?.map((val) => (
                    <SwiperSlide>
                      <div className="cat_div_card">
                        <div
                          className="img_holder"
                          onClick={() =>
                            handleCategoryClick(val?.id, val?.name, val?.image)
                          }
                        >
                          <img
                            src={process.env.REACT_APP_IMG_URL + val?.image}
                            className="img_inner"
                          />
                        </div>
                        <p
                          className="cat_name"
                          onClick={() =>
                            handleCategoryClick(val?.id, val?.name, val?.image)
                          }
                        >
                          {val?.name}
                        </p>

                        <div className="btn_holder">
                          <Black_Btn
                            btnText={"Explore"}
                            onClick={() =>
                              handleCategoryClick(
                                val?.id,
                                val?.name,
                                val?.image,
                              )
                            }
                          />
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Categories;
